var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-absolute widget-wrapper no-rows-no-image",style:(("left: " + (_vm.xPos - 310) + "px; top: 115px;"))},[_c('div',[_c('Table',{attrs:{"config":_vm.config,"rows":_vm.preferredPayersForPayment,"filters":null},scopedSlots:_vm._u([{key:"payerType",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.payer)+" ")]}},{key:"effectiveDate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.effectiveDate)+" ")]}},{key:"amount",fn:function(ref){
var item = ref.item;
return [_c('b',[_vm._v(_vm._s(_vm._f("currency")(item.amount)))])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }